/** Maximum number of tools that can be compared at once */
export const MAX_COMPARE_TOOLS = 5;

/** Minimum number of tools required to enable comparison */
export const MIN_COMPARE_TOOLS = 2;
/** UXM Analytics event names */
export const COMPARE_ANALYTICS_EVENTS = {
  TOGGLE: "aiforme-compare-toggle",
  BAR: "aiforme-compare-bar",
  FLYOUT: "aiforme-compare-flyout",
} as const;

/** Compare bar actions for analytics */
export const COMPARE_BAR_ACTIONS = {
  CANCEL: "cancel",
  REMOVE_CHIP: "remove-chip",
  COMPARE_NOW: "compare-now",
} as const;

/** Compare flyout actions for analytics */
export const COMPARE_FLYOUT_ACTIONS = {
  OPEN: "open",
  CLOSE: "close",
  REMOVE_TOOL: "remove-tool",
} as const;
